import AssetTypes from './assetTypes'

export default AssetTypes
